/* tslint:disable:max-line-length */
enum IconsQA {
  AfterPayIcon = 'AfterPayIcon',
  AffirmIcon = 'AffirmIcon',
  KlarnaIcon = 'KlarnaIcon',
  PaypalIcon = 'PaypalIcon',
  AmexCardIcon = 'AmexCardIcon',
  DiscoverCardIcon = 'DiscoverCardIcon',
  MasterCardIcon = 'MasterCardIcon',
  VisaCardIcon = 'VisaCardIcon',
}

export default IconsQA
